import * as React from 'react';
import styles from './index.less';

const DEFAULT_TABS = [{ id: 0, title: '赛事概览' }, { id: 1, title: '帮会集结' }, { id: 2, title: '逐鹿天下' }, { id: 3, title: '比赛奖励' }];

const TAB_STYLE_NAMES = [styles.overviewTab, styles.guildTab, styles.competitionTab, styles.rewardsTab];

const ActivityHeader = ({ activeTab, tabs = DEFAULT_TABS, onTabChange, sloganUrl }) => {
  const activeIndex = tabs.findIndex(item => item.id === activeTab);
  const canChangeTab = typeof onTabChange === 'function';

  return (
    <header className={styles.root}>
      <div className={styles.content}>
        <a className={styles.logo} href="//jxsj.xoyo.com/index/" target="_blank" rel="noopener noreferrer">
          剑侠世界
        </a>
        <nav className={styles.topbar} aria-label="剑侠世界快捷入口">
          <a href="//jxsj.xoyo.com/index/" target="_blank" rel="noopener noreferrer">
            官网首页
          </a>
          <a href="//jxsj.xoyo.com/download/" target="_blank" rel="noopener noreferrer">
            游戏下载
          </a>
          <a className={styles.lastTopbarLink} href="//passport.xoyo.com/signup?origin=jxsj" target="_blank" rel="noopener noreferrer">
            账号注册
          </a>
        </nav>
        {sloganUrl ? <img className={styles.slogan} src={sloganUrl} alt="" aria-hidden="true" /> : null}
        <nav className={styles.tabs} aria-label="赛事内容" role="tablist">
          {tabs.map((item, index) => {
            const isActive = index === activeIndex;
            const className = [styles.tab, TAB_STYLE_NAMES[index], isActive ? styles.activeTab : ''].filter(Boolean).join(' ');

            return (
              <button
                type="button"
                className={className}
                role="tab"
                aria-selected={isActive}
                aria-controls={`main-panel-${item.id}`}
                data-tab-id={item.id}
                disabled={!canChangeTab}
                key={`${item.id}-${index}`}
                onClick={() => {
                  if (canChangeTab) {
                    onTabChange(item.id);
                  }
                }}
              >
                {item.title}
              </button>
            );
          })}
        </nav>
      </div>
    </header>
  );
};

ActivityHeader.defaultProps = {
  activeTab: 0,
  tabs: DEFAULT_TABS,
  onTabChange: undefined,
  sloganUrl: ''
};

export { DEFAULT_TABS };
export default ActivityHeader;
